<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     name: '',
     code: '',
     email: '',
     mobile: '',
     address: '',
    };
  },
  methods: {
  
   branch(row = null) {
    this.resetForm();
    if(row != null){
     this.setLoading(true);    
     try{
      this.id = row.id;
      this.name = row.name;
      this.code = row.code;
      this.email = row.email;
      this.mobile = row.mobile;
      this.address = row.address;
     }finally{
      this.setLoading(false);
     } 
     
    }
   },  

   async saveBranch(){
    this.errors = {};
    this.setLoading(true); 

    try{
     const payload = {
      id: this.id,
      name: this.name,
      code: this.code,
      email: this.email,
      mobile:  this.mobile,
      address: this.address  
     };
     let response = [];
     if(this.id){
      response = await axios.put(`/branches/${this.id}/update`, payload);  
     }else{
      response = await axios.post(`/branches/create`, payload);  
     }
     this.$swalToast(response.data.message);
     this.$emit('updated'); 
     this.closeModal('branch_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteBranch(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/branches/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
    this.closeModal('delete_modal');
   }finally{
    this.setLoading(false);
   }
  }, 

  async removeFile(){
   const result = await this.$confirm({});
    if(result.isConfirmed){ 
   this.setLoading(true);
   try{
    const response = await axios.delete(`/banks/${this.id}/image/remove`);
    this.$swalToast(response.data.message);
    this.$emit('updated'); 
    this.closeModal('branch_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   } 
   }
  },

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.code = '';
   this.email = '';
   this.mobile = '';
   this.address = '';
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="branch_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Branch</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="saveBranch" enctype="multipart/form-data">
          <div class="modal-body pb-0">
            <div class="row">
              
              <div class="col-md-8">
                <div class="mb-3">
                  <label class="form-label">Branch Name</label>
                  <input type="text" class="form-control" v-model="name" />
                  <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Branch Code</label>
                  <input type="text" class="form-control" v-model="code" />
                  <div v-if="errors.code" class="text-danger small mt-1">{{ errors.code[0] }}</div>
                </div>
              </div>

              <div class="col-md-8">
                <div class="mb-3">
                  <label class="form-label">Email</label>
                  <input type="text" class="form-control" v-model="email" />
                  <div v-if="errors.email" class="text-danger small mt-1">{{ errors.email[0] }}</div>
                </div>
              </div> 

              <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Mobile No</label>
                  <input type="text" class="form-control" v-model="mobile" />
                  <div v-if="errors.mobile" class="text-danger small mt-1">{{ errors.mobile[0] }}</div>
                </div>
              </div> 

              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Address</label>
                  <input type="text" class="form-control" v-model="address" />
                  <div v-if="errors.address" class="text-danger small mt-1">{{ errors.address[0] }}</div>
                </div>
              </div> 
              
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteBranch">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
